import { LastBookingsState } from './types';

export const initialState: LastBookingsState = {
  loading: false,
  currentRequestId: undefined,
};
